import { ShortCode } from '@highereducation/wordpress';
import { BrandCardContainer } from '@highereducation/hen-ui';

type BrandCardContainerShortcodeProps = {
  children: React.ReactNode;
};

export const BrandCardContainerShortcode: ShortCode<BrandCardContainerShortcodeProps> =
  {
    component: ({ children }) => {
      return <BrandCardContainer>{children}</BrandCardContainer>;
    },
  };
